"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ONBOARDING_STAGES = void 0;
// Should be kept in sync with ONBOARDING_STAGES enum in backend
var ONBOARDING_STAGES = /*#__PURE__*/function (ONBOARDING_STAGES) {
  ONBOARDING_STAGES["START"] = "start";
  ONBOARDING_STAGES["TEMPEST_CONSENT"] = "tempest.consent";
  ONBOARDING_STAGES["SERVICE_INSURANCE"] = "service.insurance";
  ONBOARDING_STAGES["SERVICE_CLINICIANS"] = "service.clinicians";
  ONBOARDING_STAGES["CHECKOUT_INSURANCE_SUBMISSION"] = "checkout.insurance-submission";
  ONBOARDING_STAGES["CHECKOUT_INSURANCE_ELIGIBILITY"] = "checkout.insurance-eligibility";
  ONBOARDING_STAGES["SCHEDULE_THERAPIST"] = "schedule.therapist";
  ONBOARDING_STAGES["SCHEDULE_PHYSICIAN"] = "schedule.physician";
  ONBOARDING_STAGES["CHECKOUT_PAYMENT"] = "checkout.payment";
  ONBOARDING_STAGES["CHECKOUT_SUCCESS"] = "checkout.success";
  ONBOARDING_STAGES["PROFILE_PERSONAL_INFO"] = "profile.personal-info";
  ONBOARDING_STAGES["PROFILE_CONTACT_INFO"] = "profile.contact-info";
  ONBOARDING_STAGES["PROFILE_EMERGENCY_CONTACT"] = "profile.emergency-contact";
  ONBOARDING_STAGES["INTAKE_SURVEY"] = "intake.survey";
  ONBOARDING_STAGES["PROFILE_REVIEW"] = "profile.review";
  ONBOARDING_STAGES["COMPLETE"] = "complete";
  ONBOARDING_STAGES["EXITED"] = "exited";
  ONBOARDING_STAGES["NULL_STATE"] = "null-state";
  ONBOARDING_STAGES["ACCOUNT_LOCATION"] = "account.location";
  return ONBOARDING_STAGES;
}({});
exports.ONBOARDING_STAGES = ONBOARDING_STAGES;